import { MpsRoleHelper } from '../helpers/mps-role.helper';
import { MpsIRole, MpsIUser } from '../interfaces/mps-user.interface';

export class MpsUser implements MpsIUser {
  id!: number;
  firstname!: string;
  lastname!: string;
  email!: string;
  lang!: string;
  last_connection!: string;
  igg!: string;
  role_id!: number;
  subsidiary_id?: number | null;

  role!: MpsRole;

  constructor(data = {}) {
    Object.assign(this, data);
  }

  isAdmin() {
    // ADMIN (squelette) et SUPERADMIN (porté d'OSER) ont les mêmes droits.
    return MpsRoleHelper.ADMIN_ROLES.some((code) => this.isRole(code));
  }

  isSubsidiaryAdmin() {
    return this.isRole(MpsRoleHelper.SUBSIDIARY_ADMIN);
  }

  isRole(roleCode: string) {
    return this.role?.code?.toUpperCase() === roleCode.toUpperCase();
  }
}

export class MpsRole implements MpsIRole {
  id!: number;
  label!: string;
  code!: string;

  constructor(data = {}) {
    Object.assign(this, data);
  }
}
